import { mergeStyleSets } from "@fluentui/react";

export const MetadataManagementStyles = mergeStyleSets({
  container: {
    padding: '20px',
    maxWidth: '1400px',
    margin: '0 auto'
  },
  errorMessage: {
    color: 'rgb(164, 38, 44)',
    fontSize: '12px',
    fontWeight: 400,
    marginTop: '5px'
  }
});
